module.exports = __webpack_public_path__ + "static/media/MHRP25L0501.40086e83.svg";